import toastr from 'toastr'
import { funcModal } from 'components/modals'

const PERIODS = [
  { value: '60', label: '1 minute', seconds: 60 },
  { value: '300', label: '5 minutes', seconds: 300 },
  { value: '600', label: '10 minutes', seconds: 600 },
  { value: '1800', label: 'Half hour (30 min)', seconds: 1800 },
  { value: '3600', label: '1 hour', seconds: 3600 },
  { value: '86400', label: '1 day', seconds: 86400 },
  { value: 'custom', label: 'Custom', seconds: null }
]

const ROUTE_EXAMPLES = [
  'api.all',
  'api.locations.all',
  'api.locations.search',
  'api.locations.types',
  'api.locations.min-price',
  'api.locations.show',
  'api.reservations.store',
  'api.reservations.refund-percentage',
  'api.reservations.all',
  'api.reservations.cancel',
  'api.reservations.partial-cancel',
  'api.reservations.rollback',
  'api.reservations.update',
  'api.reservations.destroy',
  'api.reservations.rates-breakdown',
  'api.reservations.costs',
  'api.general.amenities',
  'api.general.currencies',
  'api.general.base-types',
  'api.general.bed-types',
  'api.general.validate-reservation-input'
]

const components = {
  funcModal
}

const methods = {
  open (item) {
    this.errors = {}
    this.showRouteExamples = false
    if (item && item.id) {
      this.form = _.cloneDeep(item)
      this.form.is_enabled = !!this.form.is_enabled
      this.syncPeriodFromSeconds(this.form.window_seconds)
    } else {
      this.resetForm()
    }
    this.$refs.modal.open()
  },

  resetForm () {
    this.form = {
      route: null,
      max_requests: null,
      window_seconds: 1800,
      is_enabled: true
    }
    this.selectedPeriod = '1800'
  },

  selectRoute (route) {
    this.form.route = route
  },

  syncPeriodFromSeconds (seconds) {
    const match = _.find(PERIODS, (period) => {
      return period.value !== 'custom' && period.seconds == seconds
    })
    if (match) {
      this.selectedPeriod = match.value
    } else {
      this.selectedPeriod = 'custom'
    }
  },

  onPeriodChange () {
    if (this.selectedPeriod === 'custom') {
      return
    }
    const match = _.find(PERIODS, { value: this.selectedPeriod })
    if (match) {
      this.form.window_seconds = match.seconds
    }
  },

  submit (modal) {
    this.errors = {}
    this.processing = true

    const channel_id = this.$route.params.id
    const data = {
      route: this.form.route,
      max_requests: this.form.max_requests,
      window_seconds: this.form.window_seconds,
      is_enabled: !!this.form.is_enabled
    }
    const isEdit = !!this.form.id

    const action = isEdit
      ? this.$store.dispatch('channels.updateApiRateLimit', {
          channel_id,
          id: this.form.id,
          data
        })
      : this.$store.dispatch('channels.addApiRateLimit', {
          channel_id,
          data
        })

    action.then(() => {
      this.processing = false
      let errors = this.$store.state.channels.errors
      if (errors) {
        if (errors.errors) {
          this.errors = _.cloneDeep(errors.errors)
        }
        toastr.error(errors.message)
      } else {
        toastr.success(isEdit ? 'Rate limit updated successfully' : 'Rate limit created successfully')
        modal.close()
        this.resetForm()
        this.$emit('saved')
      }
    })
  }
}

export default {
  name: 'api-rate-limit-form-modal',
  components,
  methods,
  data () {
    return {
      processing: false,
      errors: {},
      selectedPeriod: '1800',
      periods: PERIODS,
      routeExamples: ROUTE_EXAMPLES,
      showRouteExamples: false,
      form: {
        route: null,
        max_requests: null,
        window_seconds: 1800,
        is_enabled: true
      }
    }
  },
  computed: {
    modalTitle () {
      return this.form && this.form.id ? 'Update API Rate Limit' : 'New API Rate Limit'
    }
  }
}
